export const CONTACT_SUPPORT_URL = "https://support.fishtracking.innovasea.com/s/contactsupport";
